// src/components/Shared/TopBar.jsx
import React from 'react';
import logo1 from '../../images/logo1.PNG'; 

export default function TopBarLogo() {
  return (
    <div style={{
      backgroundColor: '#4c007d',
      padding: '10px 20px',
      display: 'flex',
      alignItems: 'center',
      color: 'white'
    }}>
      <img src={logo1} alt="Logo" style={{ height: '40px', marginRight: '10px' }} />
      <span style={{ fontSize: '20px', fontWeight: 'bold' }}>Mercanteomexico.com</span>
    </div>
  );
}
